// Leading icon for status chip for submission list table
export function getLeadingIcon(status: string): string {
  switch (status.toLowerCase()) {
    case 'draft':
      return 'edit';
    case 'pre-review':
    case 'review':
      return 'lock';
    case 'outcome':
    case 'complete':
      return 'check_circle';
    case 'todo':
    case 'onhold':
    case 'on_hold':
      return 'error';
    default:
      return '';
  }
}

// Label mapping for submission status
export function getStatusLabel(status: string): string {
  switch (status.toLowerCase()) {
    case 'onhold':
    case 'on_hold':
      return 'Hold';
    case 'todo':
      return 'To Do';
    default:
      return status;
  }
}
